import React from "react";
import BrickwallBrick from "./BrickwallBrick";

const BrickwallGrid = ({
	wallData,
	occupied,
	selectedBricks,
	hoveredBrick,
	donationAmount,
	canPlaceBrick,
	isConnectedToSelection,
	isBrickAvailable,
	onBrickMouseDown,
	onBrickMouseEnter,
	donorName,
	brickColor,
	hideNameOnBrick,
	hideAmountOnBrick,
	config,
	register,
	errors,
	setValue,
	watch,
	trigger,
	onDonate,
	onClearSelection,
}) => {
	const ROWS_ABOVE_TOPMOST = 2;

	// Find the topmost occupied brick (only use occupied, not selectedBricks,
	// so the number of rows doesn't change when selecting bricks)
	let topmostRow = -1; // Start at -1 so if no bricks exist, we still show rows
	occupied.forEach((_, key) => {
		const row = parseInt(key.split(",")[0], 10);
		if (row > topmostRow) topmostRow = row;
	});

	// Calculate max row to render: topmostRow + 1 (for the row above) + 1 (because array is 0-indexed)
	// If no bricks exist (topmostRow = -1), show at least ROWS_ABOVE_TOPMOST rows
	const maxRowToRender =
		topmostRow >= 0
			? Math.min(topmostRow + ROWS_ABOVE_TOPMOST + 1, wallData.rows)
			: Math.min(ROWS_ABOVE_TOPMOST, wallData.rows);

	return (
		<div className="brickwall-grid-container">
			<div className="brickwall-grid-inner">
				{Array.from({ length: maxRowToRender }, (_, row) => {
					const actualBricksCount =
						wallData.bricksPerRow - (row % 2 === 1 ? 1 : 0);

					return (
						<div key={row} className="brickwall-row">
							{Array.from({ length: actualBricksCount }, (_, index) => {
								// Actual brick logic
								const col = index;
								const brickKey = `${row},${col}`;
								const donation = occupied.get(brickKey);
								const isSelected = selectedBricks.has(brickKey);
								const isHovered = hoveredBrick === brickKey;
								const canPlace = canPlaceBrick(row, col);
								const isConnected = isConnectedToSelection(row, col);
								const isAvailable = isBrickAvailable(row, col);

								return (
									<BrickwallBrick
										key={`${row}-${col}`}
										row={row}
										col={col}
										donation={donation}
										isSelected={isSelected}
										isHovered={isHovered}
										canPlace={canPlace}
										isConnected={isConnected}
										isAvailable={isAvailable}
										onMouseDown={onBrickMouseDown}
										onMouseEnter={onBrickMouseEnter}
										brickPrice={wallData.brickPrice}
										selectedAmount={donationAmount}
										donorName={donorName}
										brickColor={brickColor}
										hideNameOnBrick={hideNameOnBrick}
										hideAmountOnBrick={hideAmountOnBrick}
										config={config}
										register={register}
										errors={errors}
										setValue={setValue}
										watch={watch}
										trigger={trigger}
										onDonate={onDonate}
										onClearSelection={onClearSelection}
									/>
								);
							})}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default BrickwallGrid;
